import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "preview",
  "use": "preview-usage",
  "viewBox": "0 0 56.42 61",
  "content": "<symbol viewBox=\"0 0 56.42 61\" id=\"preview\"><title>资源 41</title><g id=\"preview_图层_2\" data-name=\"图层 2\"><g id=\"preview_图层_1-2\" data-name=\"图层 1\"><path d=\"M11.44,11.5h30.5v3.81H11.44Zm-.1,7.66h30.5V23H11.34ZM3.81,3.81H49.56v30.5h3.81V3.81A3.81,3.81,0,0,0,49.56,0H3.81A3.81,3.81,0,0,0,0,3.81V57.19A3.81,3.81,0,0,0,3.81,61H30.5V57.19H3.81Zm7.6,30.6v3.81h9.27a13.34,13.34,0,0,1,.55-3.81ZM27,26.79H11.34V30.6H22.93A13.42,13.42,0,0,1,27,26.79ZM55.87,57.47l-8.74-8.64a13.33,13.33,0,1,0-2.88,2.51l8.93,8.82a1.91,1.91,0,1,0,2.7-2.7ZM27.47,40.13A9.53,9.53,0,1,1,37,49.67a9.53,9.53,0,0,1-9.53-9.53Zm0,0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/preview.svg
// module id = Zwwz
// module chunks = 264